import type { UpdateInfiniteProfileRequest } from '~/types/loyaltyContract';

export type InfiniteProfileFormState = NonNullable<UpdateInfiniteProfileRequest['profile']>;
export type BookingAuthorityFormState = NonNullable<UpdateInfiniteProfileRequest['bookingAuthorities']>[number];

export const TITLE_OPTIONS: Array<{ value: '' | 'MR' | 'MRS' | 'MS' | 'MISS'; label: string }> = [
  { value: '', label: 'Not set' },
  { value: 'MR', label: 'Mr' },
  { value: 'MRS', label: 'Mrs' },
  { value: 'MS', label: 'Ms' },
  { value: 'MISS', label: 'Miss' },
];

export function getDisplayName(
  person: Pick<App.LuxLoyaltyInfiniteProfile, 'title' | 'firstName' | 'lastName'>,
): string {
  return [person.title, person.firstName, person.lastName].filter(Boolean).join(' ');
}

export function getPhone(
  person: Pick<App.LuxLoyaltyInfiniteProfile, 'phonePrefix' | 'phone'> | App.LuxLoyaltyInfiniteBookingAuthority,
): string {
  return [person.phonePrefix, person.phone].filter(Boolean).join(' ');
}

export function getAddress(profile: App.LuxLoyaltyInfiniteProfile): string {
  return [profile.address, profile.address2, profile.city, profile.state, profile.postcode, profile.country]
    .filter(Boolean)
    .join(', ');
}

export function normalisePhonePrefix(value: string): string {
  return value.replace(/[^0-9]/g, '');
}

export function getInitialProfileForm(profile: App.LuxLoyaltyInfiniteProfile): InfiniteProfileFormState {
  return {
    title: (profile.title as InfiniteProfileFormState['title']) ?? null,
    firstName: profile.firstName,
    lastName: profile.lastName,
    email: profile.email,
    phonePrefix: profile.phonePrefix,
    phone: profile.phone,
    address: profile.address,
    address2: profile.address2 ?? null,
    city: profile.city,
    postcode: profile.postcode,
    state: profile.state,
    country: profile.country,
    welcomePackNotes: profile.welcomePackNotes ?? null,
  };
}

export function getInitialBookingAuthorities(profile: App.LuxLoyaltyInfiniteProfile): Array<BookingAuthorityFormState> {
  return (
    profile.bookingAuthorities?.map((authority) => ({
      id: authority.id,
      title: (authority.title as BookingAuthorityFormState['title']) ?? null,
      firstName: authority.firstName,
      lastName: authority.lastName,
      email: authority.email,
      phonePrefix: authority.phonePrefix,
      phone: authority.phone,
      isDeactivated: !!authority.isDeactivated,
    })) ?? []
  );
}

export function emptyBookingAuthority(): BookingAuthorityFormState {
  return {
    title: null,
    firstName: '',
    lastName: '',
    email: '',
    phonePrefix: '+61',
    phone: '',
    isDeactivated: false,
  };
}
